/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Booking_Times_HintInputs */

const en_admin_resource_form_booking_times_hint = /** @type {(inputs: Admin_Resource_Form_Booking_Times_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E.g. For Monday through Friday, 9am to 5pm, enter 'mo - fr 9am - 5pm'. To make the resource always available, enter 24/7.`)
};

const de_admin_resource_form_booking_times_hint = /** @type {(inputs: Admin_Resource_Form_Booking_Times_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Montag bis Freitag, 9 bis 17 Uhr, gib z. B. "mo - fr 9am - 5pm" ein.`)
};

const es_admin_resource_form_booking_times_hint = /** @type {(inputs: Admin_Resource_Form_Booking_Times_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por ejemplo, para lunes a viernes, de 9am a 5pm, introduce "mo - fr 9am - 5pm".`)
};

const fr_admin_resource_form_booking_times_hint = /** @type {(inputs: Admin_Resource_Form_Booking_Times_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par exemple, pour lundi à vendredi, de 9 h à 17 h, entrez "mo - fr 9am - 5pm".`)
};

const nl_admin_resource_form_booking_times_hint = /** @type {(inputs: Admin_Resource_Form_Booking_Times_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bijv. voor maandag t/m vrijdag, 9:00 tot 17:00, voer in 'mo - fr 9am - 5pm'. Om de voorziening altijd beschikbaar te maken, voer 24/7 in.`)
};

/** @type {(inputs: Admin_Resource_Form_Booking_Times_HintInputs) => LocalizedString} */
const it_admin_resource_form_booking_times_hint = en_admin_resource_form_booking_times_hint;

/** @type {(inputs: Admin_Resource_Form_Booking_Times_HintInputs) => LocalizedString} */
const pt_br2_admin_resource_form_booking_times_hint = en_admin_resource_form_booking_times_hint;

/** @type {(inputs: Admin_Resource_Form_Booking_Times_HintInputs) => LocalizedString} */
const pl_admin_resource_form_booking_times_hint = en_admin_resource_form_booking_times_hint;

/** @type {(inputs: Admin_Resource_Form_Booking_Times_HintInputs) => LocalizedString} */
const hu_admin_resource_form_booking_times_hint = en_admin_resource_form_booking_times_hint;

/** @type {(inputs: Admin_Resource_Form_Booking_Times_HintInputs) => LocalizedString} */
const ro_admin_resource_form_booking_times_hint = en_admin_resource_form_booking_times_hint;

/**
* | output |
* | --- |
* | "E.g. For Monday through Friday, 9am to 5pm, enter 'mo - fr 9am - 5pm'. To make the resource always available, enter 24/7." |
*
* @param {Admin_Resource_Form_Booking_Times_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_booking_times_hint = /** @type {((inputs?: Admin_Resource_Form_Booking_Times_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Booking_Times_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_booking_times_hint(inputs)
	if (locale === "de") return de_admin_resource_form_booking_times_hint(inputs)
	if (locale === "es") return es_admin_resource_form_booking_times_hint(inputs)
	if (locale === "fr") return fr_admin_resource_form_booking_times_hint(inputs)
	if (locale === "nl") return nl_admin_resource_form_booking_times_hint(inputs)
	if (locale === "it") return it_admin_resource_form_booking_times_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_booking_times_hint(inputs)
	if (locale === "pl") return pl_admin_resource_form_booking_times_hint(inputs)
	if (locale === "hu") return hu_admin_resource_form_booking_times_hint(inputs)
	return ro_admin_resource_form_booking_times_hint(inputs)
});
export { admin_resource_form_booking_times_hint as "admin.resource_form.booking_times_hint" }